import { render } from "./PermissionTooltip.vue?vue&type=template&id=d7610494"
import script from "./PermissionTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionTooltip.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Moleculas/PermissionTooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7610494"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7610494', __exports__)) {
    api.reload('d7610494', __exports__)
  }
  
  module.hot.accept("./PermissionTooltip.vue?vue&type=template&id=d7610494", () => {
    api.rerender('d7610494', render)
  })

}


export default __exports__